<template>
  <b-modal :id="id" :size="tamanho">
    <template #modal-title>
      <slot name="modal-title">{{ tituloModal }}</slot>
    </template>

    <slot></slot>

    <template #modal-footer>
      <slot name="modal-footer">
        <div class="d-flex justify-content-end">
          <b-button
            v-if="btnCancelar"
            variant="outline-secondary"
            @click="emitirCancelar"
          >
            <i class="fa-solid fa-times mr-2"></i>
            {{ tituloCancelar || $t("GERAL.CANCELAR") }}
          </b-button>
          <b-button
            v-if="btnExcluir"
            variant="danger"
            @click="emitirExcluir"
            class="ml-2"
          >
            <i class="fa-solid fa-trash mr-2"></i>
            {{ tituloExcluir || $t("GERAL.EXCLUIR") }}
          </b-button>
          <b-button v-if="btnSalvar" variant="success" @click="emitirOk" class="ml-2">
            <i class="fa-solid fa-check mr-2"></i>
            {{ tituloSalvar || $t("GERAL.SALVAR") }}
          </b-button>
        </div>
      </slot>
    </template>
  </b-modal>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: () => {
        return `modal-${Math.random()}`;
      },
    },
    tituloCancelar: {
      type: String,
      default: null,
    },
    tituloSalvar: {
      type: String,
      default: null,
    },
    tituloExcluir: {
      type: String,
      default: null,
    },
    tituloModal: {
      type: String,
      default: "Modal",
    },
    tamanho: {
      type: String,
      default: "full",
    },
    btnCancelar: {
      default: true,
    },
    btnSalvar: {
      default: true,
    },
    btnExcluir: {
      default: false,
    },
  },
  methods: {
    abrirModal: function () {
      this.$bvModal.show(this.id);
    },
    fecharModal: function () {
      this.$nextTick(() => {
        this.$bvModal.hide(this.id);
      });
    },
    emitirOk: function (e) {
      e.preventDefault();
      this.$emit("ok");
    },
    emitirExcluir: function (e) {
      e.preventDefault();
      this.$emit("excluir");
    },
    emitirCancelar: function () {
      this.fecharModal();
      this.$emit("cancelar");
    },
  },
};
</script>
<style lang=""></style>
